import React from 'react';
import PropTypes from 'prop-types';
import {
  TextTitle,
  getPanelErrorProps,
  ValidatedFixedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { AppPanel } from '@bingads-webui-campaign-react/app-store-selector';

import { SingleLineShimmer, withShimmer } from '../shimmers';

export const AppDetailsPanel = (props) => {
  const {
    key, isLoading, data = {}, ...rest
  } = props;
  const { campaign } = data || {};
  const selectedApp = campaign && campaign.AppSetting;

  const AppPanelWithShimmer = withShimmer(AppPanel, SingleLineShimmer);

  return (
    <ValidatedFixedPanel
      key={key}
      title={<TextTitle titleKey={_TL_('App details')} />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      {...rest}
    >
      <AppPanelWithShimmer
        selectedApp={selectedApp}
        showShimmer={isLoading}
        readOnly
      />
    </ValidatedFixedPanel>
  );
};

AppDetailsPanel.propTypes = {
  key: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  data: PropTypes.shape({
    campaign: PropTypes.shape({
      AppSetting: PropTypes.shape({}),
    }),
  }),
  platform: PropTypes.string.isRequired,
};

AppDetailsPanel.defaultProps = {
  isLoading: false,
  data: {},
};
